import { render, staticRenderFns } from "./ConsultaClaComponent.vue?vue&type=template&id=1f7a23f6&scoped=true"
import script from "./ConsultaClaComponent.vue?vue&type=script&lang=js"
export * from "./ConsultaClaComponent.vue?vue&type=script&lang=js"
import style0 from "./ConsultaClaComponent.vue?vue&type=style&index=0&id=1f7a23f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7a23f6",
  null
  
)

export default component.exports